/**
 * Supreme Concrete — location state.
 * Single source of truth for per-location contact data + cookie helpers.
 * Loaded globally from layout/theme.liquid.
 */
(function () {
  'use strict';

  var DATA = {
    ny: {
      key: 'ny',
      label: 'New York',
      phoneDisplay: '(929) 347-6233',
      phoneTel: '19293476233',
      address: '235 W 109th St Apt 6C, New York, NY 10025',
      pageUrl: '/pages/locations-new-york'
    },
    la: {
      key: 'la',
      label: 'Los Angeles',
      phoneDisplay: '+1-833-453-15-38',
      phoneTel: '18334531538',
      address: '505 N Figueroa, Los Angeles, California, 90012',
      pageUrl: '/pages/locations-los-angeles'
    }
  };

  var COOKIE = 'sc_location';
  var DEFAULT = 'la';
  var ONE_YEAR = 60 * 60 * 24 * 365;

  function readCookie() {
    var match = document.cookie.match(/(?:^|;\s*)sc_location=(ny|la)(?:;|$)/);
    return match ? match[1] : null;
  }

  function writeCookie(value) {
    if (value !== 'ny' && value !== 'la') return;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE + '=' + value +
      '; path=/; max-age=' + ONE_YEAR +
      '; SameSite=Lax' + secure;
  }

  function current() {
    return readCookie() || DEFAULT;
  }

  function get(key) {
    return DATA[key] || DATA[DEFAULT];
  }

  function hydrate(root) {
    root = root || document;
    var loc = get(current());

    root.querySelectorAll('[data-sc-loc-phone]').forEach(function (el) {
      el.textContent = loc.phoneDisplay;
    });
    root.querySelectorAll('[data-sc-loc-address]').forEach(function (el) {
      el.textContent = loc.address;
    });
    root.querySelectorAll('[data-sc-loc-label]').forEach(function (el) {
      el.textContent = loc.label;
    });
    root.querySelectorAll('[data-sc-loc-tel-href]').forEach(function (a) {
      a.setAttribute('href', 'tel:+' + loc.phoneTel);
    });
    root.querySelectorAll('[data-sc-loc-page-href]').forEach(function (a) {
      a.setAttribute('href', loc.pageUrl);
    });
  }

  function syncCartAttribute() {
    if (!window.fetch) return;
    var loc = current();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { location: loc } })
    }).catch(function () { /* swallow — cart might not exist yet */ });
  }

  window.SCLocation = {
    current: current,
    get: get,
    set: function (value) {
      writeCookie(value);
      document.documentElement.setAttribute('data-sc-loc', value);
      hydrate();
      syncCartAttribute();
    },
    hydrate: hydrate,
    syncCartAttribute: syncCartAttribute,
    DATA: DATA
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(); });
  } else {
    hydrate();
  }

  if (location.pathname.indexOf('/cart') === 0) {
    syncCartAttribute();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sc-loc-set]');
    if (!a) return;
    var v = a.getAttribute('data-sc-loc-set');
    if (v === 'ny' || v === 'la') {
      writeCookie(v);
    }
  }, true);
})();
